import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ExamDayRatingType, ExamType } from '@ils/static/enums.js';
import { badgeStylePositive, badgeStyleSm } from '@ils/theme/badges.js';
import { getColorForExamType, getColorForRatingType } from '@ils/theme/theme.js';
import { html } from 'lit';

export const examTypeBadgeStyle = (
  examType?: Maybe<ExamType>,
  ratingType?: Maybe<ExamDayRatingType>,
  small = false,
): { isLegacy: Maybe<boolean>; style: Styles } => {
  const [background, color] = getColorForExamType(examType ?? ExamType.FAMED);
  const [backgroundRating, colorRating] = getColorForRatingType(ratingType ?? ExamDayRatingType.FAMED);
  const isLegacy = examType === ExamType.FAMED && ratingType && ratingType !== ExamDayRatingType.FAMED;
  return {
    isLegacy,
    style: {
      ...badgeStylePositive(),
      ...(small ? badgeStyleSm() : {}),
      background: isLegacy ? backgroundRating : background,
      color: isLegacy ? colorRating : color,
    },
  };
};

export const examTypeBadge = (examType?: Maybe<ExamType>, ratingType?: Maybe<ExamDayRatingType>, small = false) => {
  const { isLegacy, style } = examTypeBadgeStyle(examType, ratingType, small);
  return html`
    <x-text ${css(style)}>
      ${isLegacy
        ? clientTranslator.translate('ratingType', ratingType, 'short')
        : clientTranslator.translate('examType', examType ?? 'other', 'short')}
    </x-text>
  `;
};
